import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import styles from './styles';
import { useTranslation } from 'react-i18next';
import { CheckboxSelectedSVG, CheckboxSVG } from './svgs/Checkbox';

type Props = {
  label?: string;
  choices: string[];
  selectedValue: string;
  labelStyle?: any;
  choiceStyle?: any;
  baseMessage: string;
};

function InputWithChoice({
  label,
  choices,
  selectedValue,
  labelStyle,
  choiceStyle,
  baseMessage,
}: Props) {
  const { t } = useTranslation();

  return (
    <View style={styles.choiceInputContainer}>
      {label && <Text style={[styles.label, labelStyle]}>{t(label)}</Text>}
      <View style={styles.choiceGroup}>
        {choices.map((choice, index) => (
          <View key={index} style={styles.choiceItem}>
            {selectedValue === choice ? <CheckboxSelectedSVG /> : <CheckboxSVG />}
            <Text style={[styles.choiceLabel, choiceStyle]}>{t(`${baseMessage}.${choice}`)}</Text>
          </View>
        ))}
      </View>
    </View>
  );
}

export default InputWithChoice;
